import React from 'react'

function SinglePortfolio({content : {name,img,url,type}}) {
    return (
         <div className={`filter-item ${type}`}>
            <div className="grid-img-container">
                <img src={img} alt="Ashish Gupta"/>
            </div>
            <div className="grid-content">
                {/* <h1>{name}</h1> */}
                <a href={url} target="_blank" rel="noreferrer" >Live View</a>
            </div>
        </div>
    )
}

export default SinglePortfolio
